import { Injectable, Type, ComponentFactoryResolver, Injector, RendererFactory2, ApplicationRef, ComponentRef } from '@angular/core';
import { NotificationsBaseComponent } from './notifications.component';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private _renderer;
  private _component: ComponentRef<NotificationsBaseComponent> | undefined;

  constructor(
    public injector: Injector,
    public rendererFactory: RendererFactory2,
    public componentResolver: ComponentFactoryResolver,
    public applicationRef: ApplicationRef
  ) {
    this._renderer = rendererFactory.createRenderer(null, null);
  }

  public open(type: Type<NotificationsBaseComponent>, data: any) {
    const factory = this.componentResolver.resolveComponentFactory(type);

    const component = factory.create(this.injector);
    this._component = component;
    const instance = component.instance;

    let ticket: any;

    const promise = new Promise((resolve, reject) => {
      ticket = { resolve, reject };
      instance.initialize(Object.assign(data, { ticket: ticket }));
      component.changeDetectorRef.detectChanges();

      this.applicationRef.attachView(component.hostView);

      const domElem = (component.hostView as any).rootNodes[0];

      this._renderer.appendChild(document.body, domElem);
    });

    return promise
      .then((ret) => {
        ticket.resolve();
        this.destroyComponent(component);
        return ret;
      })
      .catch((err) => {
        ticket.reject();
        this.destroyComponent(component);
        return err;
      });
  }

  destroyComponent(component: ComponentRef<NotificationsBaseComponent>) {
    component.instance.close();
    this.applicationRef.detachView(component.hostView);
    component.destroy();
  }

  destroy() {
    if (this._component) {
      this.destroyComponent(this._component);
    }
  }
}
